import { render, staticRenderFns } from "./PackagePitch.vue?vue&type=template&id=6a7446f6&scoped=true&"
import script from "./PackagePitch.vue?vue&type=script&lang=js&"
export * from "./PackagePitch.vue?vue&type=script&lang=js&"
import style0 from "./PackagePitch.vue?vue&type=style&index=0&id=6a7446f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7446f6",
  null
  
)

export default component.exports